<template>
  <template v-if="segment.hasStructuredItems">
    <p v-if="segment.intro" class="rat-mascot-reply-intro">
      <template v-for="(part, idx) in segment.introParts" :key="`${segmentKey}-intro-${idx}`">
        <strong v-if="part.bold">{{ part.text }}</strong>
        <template v-else>{{ part.text }}</template>
      </template>
    </p>
    <div class="rat-mascot-reply-cards">
      <article
        v-for="item in segment.items"
        :key="`${segmentKey}-item-${item.index}`"
        class="rat-mascot-reply-item-card"
      >
        <header class="rat-mascot-reply-item-card__head">
          <span class="rat-mascot-reply-item-card__num">{{ item.index }}</span>
          <span v-if="item.title" class="rat-mascot-reply-item-card__title">{{ item.title }}</span>
        </header>
        <div v-if="item.fields.length" class="rat-mascot-reply-item-card__fields">
          <div
            v-for="(field, fi) in item.fields"
            :key="`${segmentKey}-field-${item.index}-${fi}`"
            class="rat-mascot-reply-item-card__field"
          >
            <span class="rat-mascot-reply-item-card__label">{{ field.label }}</span>
            <span class="rat-mascot-reply-item-card__value">
              <span
                v-if="field.kind === 'status'"
                class="rat-mascot-reply-item-card__badge"
                :class="statusBadgeClass(field.value)"
              >{{ field.value }}</span>
              <template v-else>{{ field.value }}</template>
            </span>
          </div>
        </div>
      </article>
    </div>
    <article v-if="segment.summary" class="rat-mascot-reply-summary-card">
      <header class="rat-mascot-reply-summary-card__head">
        <span
          v-if="segment.summaryLabel"
          class="rat-mascot-reply-summary-card__badge"
          :class="summaryBadgeClass(segment.summaryLabel)"
        >{{ segment.summaryLabel }}</span>
        <span v-else class="rat-mascot-reply-summary-card__title">Summary</span>
      </header>
      <p class="rat-mascot-reply-summary-card__text">
        <template v-for="(part, idx) in segment.summaryParts" :key="`${segmentKey}-summary-${idx}`">
          <strong v-if="part.bold">{{ part.text }}</strong>
          <template v-else>{{ part.text }}</template>
        </template>
      </p>
    </article>
    <p v-if="segment.outro" class="rat-mascot-reply-outro">
      <template v-for="(part, idx) in segment.outroParts" :key="`${segmentKey}-outro-${idx}`">
        <strong v-if="part.bold">{{ part.text }}</strong>
        <template v-else>{{ part.text }}</template>
      </template>
    </p>
  </template>
  <p v-else class="rat-mascot-mascot-only-bubble__text rat-mascot-mascot-only-bubble__text--message-body">
    <template v-for="(part, idx) in segment.plainParts" :key="`${segmentKey}-plain-${idx}`">
      <strong v-if="part.bold">{{ part.text }}</strong>
      <template v-else>{{ part.text }}</template>
    </template>
  </p>
</template>

<script>
export default {
  name: 'AssistantReplyTextSegment',
  props: {
    segment: {
      type: Object,
      required: true,
    },
    segmentKey: {
      type: String,
      default: 'seg',
    },
  },
  methods: {
    statusBadgeClass(value) {
      return this.summaryBadgeClass(value, 'rat-mascot-reply-item-card__badge');
    },
    summaryBadgeClass(value, base = 'rat-mascot-reply-summary-card__badge') {
      const v = String(value || '').toLowerCase();
      if (/paid|done|complete|processed|approved|sent|active/.test(v)) {
        return `${base}--success`;
      }
      if (/pending|submitted|draft|open|due|partial/.test(v)) {
        return `${base}--warn`;
      }
      if (/overdue|rejected|failed|cancel|void|unpaid/.test(v)) {
        return `${base}--danger`;
      }
      return `${base}--neutral`;
    },
  },
};
</script>
